import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Boxes, Tag, Heart, Inbox, Send, MessageSquare, Gift, BookOpen, ClipboardList, Sparkles, ArrowLeftRight, History,
} from 'lucide-react';

export const TILES = [
  { key: 'my_materials', to: '/my-materials', icon: Boxes, color: 'text-orange-500', bg: 'bg-orange-500/10' },
  { key: 'my_listings', to: '/my-listings', icon: Tag, color: 'text-amber-500', bg: 'bg-amber-500/10' },
  { key: 'incoming_requests', to: '/requests?tab=incoming', icon: Inbox, color: 'text-red-500', bg: 'bg-red-500/10', alert: true },
  { key: 'outgoing_requests', to: '/requests?tab=my', icon: Send, color: 'text-sky-500', bg: 'bg-sky-500/10' },
  { key: 'unread_messages', to: '/messages', icon: MessageSquare, color: 'text-blue-500', bg: 'bg-blue-500/10', alert: true },
  { key: 'offers_received', to: '/wanted?tab=my', icon: Gift, color: 'text-purple-500', bg: 'bg-purple-500/10', alert: true },
  { key: 'my_offers_active', to: '/my-offers', icon: BookOpen, color: 'text-fuchsia-500', bg: 'bg-fuchsia-500/10' },
  { key: 'my_wanted_active', to: '/wanted?tab=my', icon: ClipboardList, color: 'text-violet-500', bg: 'bg-violet-500/10' },
  { key: 'wanted_matches', to: '/wanted', icon: Sparkles, color: 'text-indigo-500', bg: 'bg-indigo-500/10' },
  { key: 'transactions_active', to: '/transactions', icon: ArrowLeftRight, color: 'text-emerald-500', bg: 'bg-emerald-500/10' },
  { key: 'transactions_total', to: '/transactions', icon: History, color: 'text-teal-500', bg: 'bg-teal-500/10' },
  { key: 'watchlist', to: '/watchlist', icon: Heart, color: 'text-rose-500', bg: 'bg-rose-500/10' },
];

export const HubTiles = ({ counts }) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4" data-testid="hub-tiles">
      {TILES.map((tile, i) => {
        const Icon = tile.icon;
        const value = counts?.[tile.key] ?? 0;
        const hot = tile.alert && value > 0;
        return (
          <Link
            key={tile.key}
            to={tile.to}
            data-testid={`hub-tile-${tile.key}`}
            style={{ animationDelay: `${i * 40}ms` }}
            className={`group relative overflow-hidden rounded-xl border bg-card p-4 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md animate-in fade-in slide-in-from-bottom-2 ${
              hot ? 'border-orange-400/60 ring-1 ring-orange-400/30' : 'border-border'
            }`}
          >
            <div className={`inline-flex h-9 w-9 items-center justify-center rounded-lg ${tile.bg} ${tile.color} mb-3`}>
              <Icon className="h-4.5 w-4.5 h-[18px] w-[18px]" />
            </div>
            <p className="text-2xl font-bold font-manrope tabular-nums" data-testid={`hub-tile-value-${tile.key}`}>{value}</p>
            <p className="text-xs text-muted-foreground mt-0.5 leading-tight">{t(`hub.tile.${tile.key}`)}</p>
            {hot && <span className="absolute top-3 right-3 h-2 w-2 rounded-full bg-orange-500 animate-pulse" />}
          </Link>
        );
      })}
    </div>
  );
};
